import React from 'react'

import './ProgressBar.css'

export default function progressBar() {
    function progressBarScroll() {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop,
            height = document.documentElement.scrollHeight - document.documentElement.clientHeight,
            scrolled = (winScroll / height) * 100;
        document.getElementById("progressBar").style.width = scrolled + "%";
    }

    window.onscroll = function () {
        progressBarScroll();
    };
  return (
      <>
          <div className="header">
              <div className="progress-container">
                  <div className='progressBar' id="progressBar"></div>
              </div>
          </div>      
      </>
  )
}
